import { IRoutes } from '@App/configs/menu'
import { IApplication } from '@App/store/application/types'
import { Segment, Segments } from '@App/store/segment/types'
import { User } from '@App/store/user/types'
import { Roles } from '@App/store/role/types'

export function userAppHasSegment(segment?: Segments, currentApp?: IApplication): boolean {
  return currentApp !== undefined && segment !== undefined && currentApp.segments.some((seg: Segment) => seg.label === segment)
}

export function userHasRole(user: User, role: number): boolean {
  return user !== undefined && user.role !== undefined && user.role.value !== undefined && user.role.value >= role
}

export function userHasNot(user: User, role: number): boolean {
  return user !== undefined && user.role !== undefined && user.role.value !== undefined && user.role.value !== role
}

export function userCanAccessMenu(menu: IRoutes, user?: User, currentApp?: IApplication) {
  return userAppHasSegment(menu.segment, currentApp) || (user !== undefined && userHasRole(user, menu.role))
}

export function userIsSuperAdmin(user: User) {
  return userHasRole(user, Roles.SUPER_ADMIN)
}
